import React from "react";
import logo from './logo.png';
import { PiPhoneCallLight } from "react-icons/pi";
import { VscMail } from "react-icons/vsc";
import { useNavigate, useLocation } from "react-router-dom";


const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleClick = () => {
        if (location.pathname === "/") {
            // Eğer zaten home sayfasındaysan → direkt scroll to top
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            // Değilsen → navigate et, scroll işlemi orada yapılır
            navigate("/", { replace: false });
        }
    };


    return (
            <nav className="flex flex-wrap relative overflow-hidden ">
                {/* Sol taraf */}
                <div
                    className="flex align-items-center justify-content-start p-1 flex-1 z-10"
                    style={{ backgroundColor: "#26c165", color: "white" }}
                >
                    <img
                        src={logo}
                        alt="Logo"
                        onClick={handleClick}
                        style={{
                            width: 80,
                            height: 80,
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginRight: "1.5rem",
                            marginLeft: "2rem",
                            cursor: "pointer",
                        }}
                    />
                    <span
                        className="text-sm sm:text-base md:text-xl font-medium"
                        onClick={handleClick}
                        style={{ cursor: "pointer" }}
                    >
                        IKS - Interkulturelle Schule Rhein-Main
                    </span>
                </div>


                {/* Eğik çizgi */}
                <svg
                    viewBox="0 0 100 100"
                    preserveAspectRatio="none"
                    className="absolute h-full hidden lg:block"
                    style={{
                        width: "40px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 15,
                    }}
                >
                    <polygon points="0,0 100,0 0,100" fill="#26c165"/>
                    <polygon points="100,0 100,100 0,100" fill="#2b6cb0"/>
                </svg>

                {/* Sağ taraf */}
                <div
                    className="flex p-2 flex-1 z-10"
                    style={{
                        backgroundColor: "#2b6cb0",
                        color: "white",
                        justifyContent: "center",
                        gap: "clamp(20px, 10vw, 150px)",
                    }}
                >
                    <div className="flex align-items-center" style={{gap: "10px"}}>
                        <PiPhoneCallLight size={36} style={{flexShrink: 0, color: "#26c165"}}/>
                        <div>
                            <div className="text-sm sm:text-base md:text-xl">Telefon</div>
                            <a
                                href="tel:+496927997180"
                                className="font-medium text-sm sm:text-base md:text-xl"
                                style={{textDecoration: "none", color: "inherit"}}
                            >
                                069 279 971 80
                            </a>

                        </div>
                    </div>

                    <div className="flex align-items-center" style={{gap: "10px"}}>
                        <VscMail size={36} style={{flexShrink: 0, color: "#26c165"}}/>
                        <div>
                            <div className="text-sm sm:text-base md:text-xl">Email</div>
                            <a
                                href="mailto:info@iks-schule.de"
                                className="font-medium text-sm sm:text-base md:text-xl"
                                style={{textDecoration: "none", color: "inherit"}}
                            >
                                info@iks-schule.de
                            </a>

                        </div>
                    </div>

                </div>
            </nav>

        );

};
export default Navbar;